<template>
  <div v-cloak class="career user-message">
    <div class="titles-right font-style">我的课程</div>
    <div class="flex f-jcenter">
      <div
        class="ma-r-20 c-pointer pa-b-5"
        @click="
          tabIndex = 0;
          switType();
        "
        :class="tabIndex == 0 ? 'tab-active' : ''"
      >
        我购买的
      </div>
      <div
        class="ma-l-20 c-pointer pa-b-5"
        @click="
          tabIndex = 1;
          switType();
        "
        :class="tabIndex == 1 ? 'tab-active' : ''"
      >
        我看过的
      </div>
    </div>
    <div v-if="collects.List.length > 0 && tabIndex == 0">
      <div class="width900 flex ma-b-40 f-wrap ma-l-10">
        <div
          class="boxs_class ma-r-20 ma-t-30"
          v-for="(item, index) in collects.List"
          :key="index"
          @click="toDetail(item.CourseId)"
        >
          <img :src="item.CourseImage" class="img_263 b-r-10" />
          <img :src="item.LecturerImage" class="img_30" />
          <div class="ma-t-15 pa-lr-10 flex f-between">
            <span class="fon-12">{{ item.LecturerName }}</span
            ><span class="c-red" v-if="item.SalePrice != 0"
              ><span class="linethrough fon-12 c-8a"
                >￥{{ item.CoursePrice }}</span
              >￥{{ item.SalePrice }}</span
            >
            <span class="c-a8" v-else>免费</span>
          </div>
          <div class="t-omit-2 ma-t-15 pa-lr-10 fon-14 weight500">
            {{ item.CourseName }}
          </div>
          <div class="c-71 ma-t-10 pa-lr-10 fon-14">
            {{ item.CourseLevel }}
          </div>
        </div>
      </div>

       <div class="fy">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
              :hide-on-single-page="true"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>

    </div>
    <div v-if="collects1.List.length > 0 && tabIndex == 1">
      <div class="width900 flex ma-b-40 f-wrap ma-l-10">
        <div
          class="boxs_class ma-r-20 ma-t-30"
          v-for="(item, index) in collects1.List"
          :key="index"
          @click="toDetail(item.CourseId)"
        >
          <img :src="item.CourseImage" class="img_263 b-r-10" />
          <img :src="item.LecturerImage" class="img_30" />
          <div class="ma-t-15 pa-lr-10 flex f-between">
            <span class="fon-12">{{ item.LecturerName }}</span
            ><span class="c-red" v-if="item.SalePrice != 0"
              ><span class="linethrough fon-12 c-8a"
                >￥{{ item.CoursePrice }}</span
              >￥{{ item.SalePrice }}</span
            >
            <span class="c-a8" v-else>免费</span>
          </div>
          <div class="t-omit-2 ma-t-15 pa-lr-10 fon-14 weight500">
            {{ item.CourseName }}
          </div>
          <div class="c-71 ma-t-10 pa-lr-10 fon-14">
            {{ item.CourseLevel }}
          </div>
        </div>
      </div>

      <div class="fy">
            <el-pagination
              :hide-on-single-page="true"
              @current-change="handleCurrentChange1"
              :current-page="pageIndex1 + 1"
              :page-size="pageSize1"
              layout="prev, pager, next, jumper"
              :total="total1"
            ></el-pagination>
          </div>

    </div>


    <div v-if="(tabIndex == 0 && collects.List.length==0) || (tabIndex == 1 && collects1.List.length==0)">
      <div class="empty-box">
        <Empty></Empty>
      </div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.empty-box{
  padding-top: 200px;
}
.width900 {
  width: 900px;
}
.career {
  
  .boxs_class {
    width: 263px;
    height: 352px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    position: relative;
    .img_263 {
      object-fit: cover;
      width: 263px;
      height: 220px;
    }
    .img_30 {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: 205px;
      left: 10px;
    }
  }
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
  .fy {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .titles-right {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .titles-right:before {
    content: "|";
    display: inline-block;
    width: 4px;
    height: 19px;
    background: #234775;
    color: #234775;
    border-radius: 2px;
    margin-right: 8px;
  }
}

.career .container {
  // height: 600px;
  // min-height:500px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 0px 0px 30px 0px;
  margin: 0 auto;
  // display:flex;
  // justify-content: center;
}
.career .container {
  .el-tabs__header {
    display: flex;
    justify-content: center;
  }
  .el-tabs__content {
    // min-width:px;
    margin: 0 auto;
  }
  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }
  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: rgba(15, 117, 189, 1);
  }
  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(15, 117, 189, 1);
  }
  .el-tabs__content {
    margin-top: 15px;
  }
}
.career .student {
  width: 846px;
  height: 106px;
  margin-bottom: 32px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  .img-left {
    width: 30%;
    height: 100%;
    margin-right: 22px;
    img {
      width: 187px;
      height: 100%;
    }
  }
  .text-right {
    width: 846px;
    .title {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 12px;
    }
    .text-detail {
      padding-right: 100px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .icons {
      margin-top: 23px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .icons-left {
        width: 360px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icons-left-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
      .delete-right {
        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
    }
  }
}

.boxs {
  width: 263px;
  height: 302px;
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2) !important;
  border-radius: 10px;
  position: relative;
  .img_263 {
    width: 263px;
    height: 220px;
  }
  .img_30 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 205px;
    left: 10px;
  }
}
</style>
<script>
import { ClassSee, ClassBuy } from "../api.js";
export default {
  name: "Class",
  components: {},
  data() {
    return {
      activeName: "0",
      tabIndex: 0,
      pageIndex: 1,
      pageSize: 6,
      pageIndex1: 0,
      pageSize1: 6,
      total: 0,
      total1: 0,
      collects: { List: [] },
      collects1: { List: [] },
    };
  },
  created() {
    this.pageIndex1 = 0;
    this.getcollect();
    this.getcollects();
  },
  mounted() {},
  // 其他页面进来时更新初始数据
  activated() {},
  methods: {
    switType() {},
    handleClick(e) {
      console.log(e);
      if (e.index == 0 && this.pageIndex != 1) {
        this.pageIndex = 1;

        this.getcollect();
      } else if (e.index == 1 && this.pageIndex1 != 0) {
        this.pageIndex1 = 0;

        this.getcollects();
      }
    },
    // 购买的
    getcollect() {
      let token = localStorage.getItem("AccessToken");

      let data = {
        token: token,
        source: "web",
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };

      ClassBuy(data).then((res) => {
        if (res.data.Code == 0) {
          this.collects = res.data.Data;
          this.total = res.data.Data.TotalCount;
        }
      });
    },
    // 浏览记录
    getcollects() {
      let token = localStorage.getItem("AccessToken");

      let data = {
        token: token,
        source: "web",
        pageIndex: this.pageIndex1,
        pageSize: this.pageSize1,
      };

      ClassSee(data).then((res) => {
        if (res.data.Code == 0) {
          this.collects1 = res.data.Data;
          this.total1 = res.data.Data.TotalCount;
        }
      });
    },
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.getcollect();
    },
    handleCurrentChange1(e) {
      this.pageIndex1 = e - 1;
      this.getcollects();
    },
    toDetail(id) {
      this.$router.push({
        path: "/Learn-detail",
        query: { id: id },
      });
    },
  },
};
</script>
